import ArrowRightIcon from "../icons/ArrowRightIcon";
import CloseIcon from "../icons/CloseIcon";
import { ReactNode, useLayoutEffect, useRef } from "react";

export const TicketRoot = (props: {
  children?: React.ReactNode;
  className?: string;
  icon?: "arrow" | "close";
  handleKeyDownInList?: (item: any) => void;
  onKeyDown?: (item: any) => void;
  onClick?: (e) => void;
  iconLeft?: React.ReactNode;
  button?: boolean;
  focusOnMount?: boolean;
  title?: string;
}) => {
  const {
    children,
    button,
    className,
    icon,
    iconLeft,
    handleKeyDownInList,
    onClick,
    focusOnMount,
    title,
  } = props;
  const buttonRef = useRef<HTMLButtonElement>(null);
  useLayoutEffect(() => {
    if (focusOnMount) buttonRef.current?.focus();
  }, [focusOnMount]);
  function contents() {
    return (
      <>
        {iconLeft && <div className="c-ticket-icon">{iconLeft}</div>}
        <div className={`c-ticket-content`}>{children}</div>
        <div className={`ms-auto text-muted`}>
          {icon && icon === "arrow" ? <ArrowRightIcon width={18} /> : null}
          {icon && icon === "close" ? <CloseIcon width={18} /> : null}
        </div>
      </>
    );
  }
  if (button) {
    return (
      <button
        title={title}
        type="button"
        onClick={onClick}
        onKeyDown={handleKeyDownInList}
        className={`c-ticket ${className ?? ""}`}
        ref={buttonRef}
      >
        {contents()}
      </button>
    );
  }

  return (
    <div
      title={title}
      onClick={onClick}
      onKeyDown={handleKeyDownInList}
      className={`c-ticket ${className ?? ""}`}
    >
      {contents()}
    </div>
  );
};

export const TicketHeading = (props: {
  children: ReactNode;
  className?: string;
}) => {
  const { children, className } = props;
  return (
    <div className={`c-ticket-heading ${className ?? ""}`}>{children}</div>
  );
};

export const TicketSub = (props: {
  children: ReactNode;
  className?: string;
}) => {
  const { children, className } = props;
  return <div className={`c-ticket-sub ${className ?? ""}`}>{children}</div>;
};

export const TicketSubItem = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { children, className } = props;
  return (
    <span className={`c-ticket-sub-item ${className ?? ""}`}>{children}</span>
  );
};
